import React from "react";
import { motion } from "framer-motion";

function About() {
    return (
        <section id="about" className="min-h-screen py-20 bg-white flex items-center">
            <div className="container mx-auto px-6 flex flex-col md:flex-row items-center gap-12">
                <motion.div
                    className="w-full md:w-1/3 flex justify-center"
                    initial={{ opacity: 0, scale: 0.8 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.6 }}
                    viewport={{ once: true }}
                >
                    {/* Substituí o caminho da imagem por um placeholder visual */}
                    <div className="rounded-full w-64 h-64 md:w-80 md:h-80 bg-brand-savia/20 flex items-center justify-center shadow-lg">
                        <p className="text-brand-grafite/50">Foto de Karlla</p>
                    </div>
                </motion.div>

                <motion.div
                    className="md:w-2/3"
                    initial={{ opacity: 0, x: 50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.6 }}
                    viewport={{ once: true }}
                >
                    <h2 className="text-3xl font-bold mb-6 text-brand-grafite font-montserrat">Sobre Mim</h2>
                    <p className="text-lg text-brand-grafite/80 mb-4 leading-relaxed">
                        Sou <b>Karlla Barbosa</b>, Gestora de Recursos Humanos com mais de
                        <b> 15 anos de experiência em Gestão de Pessoas</b>.
                        Psicóloga formada pela PUC Goiás, especialista em Inovação e Criatividade Organizacional
                        e apaixonada pelo desenvolvimento humano.
                    </p>
                    <p className="text-lg text-brand-grafite/80 leading-relaxed">
                        Minha missão é atuar de forma estratégica na construção de
                        <b> culturas organizacionais saudáveis</b>, com foco no desenvolvimento e na formação de
                        <b> times de alta performance</b>.
                    </p>
                </motion.div>
            </div>
        </section>
    );
}

export default About;
